import { render, staticRenderFns } from "./VideoTutorialDialog.vue?vue&type=template&id=12f6418a&scoped=true&lang=pug"
import script from "./VideoTutorialDialog.vue?vue&type=script&lang=js"
export * from "./VideoTutorialDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoTutorialDialog.vue?vue&type=style&index=0&id=12f6418a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f6418a",
  null
  
)

export default component.exports